(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["newsletter-custom"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('ajax-newsletter-form');
    const modal = document.getElementById('successModal');
    const closeBtn = document.getElementById('closeModalBtn');
    
    if (!form || !modal) return;

    function closeModal() {
      modal.classList.remove('active');
      setTimeout(() => { modal.style.display = 'none'; }, 300);
    }

    if(closeBtn) closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => { if (e.target === modal) closeModal(); });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const submitBtn = document.getElementById('SubscribeBtn');
      const input = form.querySelector('input[type="email"]');
      const originalBtnText = submitBtn.innerText;
      
      submitBtn.disabled = true;
      submitBtn.innerText = '...';

      const formData = new FormData(form);
      formData.append('form_type', 'customer');
      formData.append('utf8', '✓');

      fetch('/contact#contact_form', {
        method: 'POST',
        body: formData
      })
      .then(() => {
        if(input) input.value = '';
        modal.style.display = 'flex';
        requestAnimationFrame(() => { modal.classList.add('active'); });
        submitBtn.innerText = originalBtnText;
        submitBtn.disabled = false;
      })
      .catch(() => {
        alert("Something went wrong.");
        submitBtn.disabled = false;
        submitBtn.innerText = originalBtnText;
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
